import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const UpcomingEvents: React.FC = () => {
	const events = [
		{
			id: "react-basic",
			title: "React入門勉強会",
			date: "2024年4月20日(土) 14:00-16:00",
			description: "Reactの基本概念と実践的な使い方を学びます",
			level: "初級",
			format: "ハイブリッド",
			capacity: 20,
			remaining: 8,
			tags: ["フロントエンド", "React", "JavaScript"],
		},
		{
			id: "python-ds",
			title: "Pythonデータサイエンス勉強会",
			date: "2024年4月27日(土) 14:00-16:00",
			description: "Pythonを使ったデータ分析の基礎を学びます",
			level: "中級",
			format: "オンライン",
			capacity: 15,
			remaining: 5,
			tags: ["Python", "データサイエンス", "統計"],
		},
		// ... 他の勉強会
	];

	return (
		<section className="py-16 bg-gray-50">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<h2 className="text-3xl font-bold mb-8">開催予定の勉強会</h2>
				<div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
					{events.map((event) => (
						<Card key={event.id}>
							<CardHeader>
								<div className="flex justify-between items-start">
									<CardTitle>{event.title}</CardTitle>
									<Badge
										variant={event.remaining < 5 ? "destructive" : "secondary"}
									>
										残り{event.remaining}席
									</Badge>
								</div>
								<CardDescription>{event.date}</CardDescription>
							</CardHeader>
							<CardContent>
								<p className="mb-4">{event.description}</p>
								<div className="space-y-2">
									<div className="flex items-center gap-2">
										<Badge variant="outline">{event.level}</Badge>
										<Badge variant="outline">{event.format}</Badge>
									</div>
									<div className="flex flex-wrap gap-2">
										{event.tags.map((tag) => (
											<Badge key={tag} variant="secondary">
												{tag}
											</Badge>
										))}
									</div>
								</div>
								<Button asChild className="w-full mt-4">
									<Link to={`/study-groups/${event.id}`}>詳細を見る</Link>
								</Button>
							</CardContent>
						</Card>
					))}
				</div>
				<div className="text-center mt-8">
					<Button asChild variant="outline">
						<Link to="/study-groups/schedule">すべての予定を見る</Link>
					</Button>
				</div>
			</div>
		</section>
	);
};

export default UpcomingEvents;
